module.exports = __webpack_public_path__ + "img/rank15.40af14a1.png";